<template>
  <ul class="report-area__date-controls">
    <li class="report-area__date-controls-item" v-if="period.isDatePeriod">
      <range-date-picker @onChange="HandleChange"></range-date-picker>
    </li>
    <li class="report-area__date-controls-item">
      <button class="report-area__date-controls-button">
        {{activePeriod}}
        <i class="material-icons md-24 color_white report-area__date-controls-button--more">expand_more</i>
        <i class="material-icons md-24 color_white report-area__date-controls-button--less">expand_less</i>
      </button>

      <ul class="period-list">
        <li class="period-list__decor"></li>
        <li class="period-list__item period-list__item--empty">
        </li>
        <li
          v-for="(item, key) in period.periodList"
          :key="key"
          @click="choosePeriod(key)"
          class="period-list__item"
        >
          <button class="period-list__item-button">{{item.title}}</button>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>
// libraries
import moment from 'moment/moment';

// components
import RangeDatePicker from './RangeDatePicker.vue';

// helpers
import { fromThirtyDays } from '../../../../../helpers/dateHelper.js';

// bus
import { bus } from '../../../../../bus.js';

// constants
const FORMAT = 'YYYY-MM-DD HH:MM:SS';

export default {
  name: 'DateControls',
  data() {
    return {
      month: [
        'янв',
        'фев',
        'мар',
        'апр',
        'май',
        'июн',
        'июл',
        'авг',
        'сен',
        'окт',
        'ноя',
        'дек',
      ],
      period: {
        periodList: [
          {
            title: 'За сегодня',
            isDatePeriod: false,
            dateRange: {
              from: moment(new Date()).format(FORMAT),
            },
            method: 'getTrustHourly',
            prepareLabels: elem => elem[0],
          },
          {
            title: 'За месяц',
            isDatePeriod: false,
            dateRange: {
              from: moment(new Date(fromThirtyDays())).format(FORMAT),
              to: moment(new Date()).format(FORMAT),
            },
            method: 'getTrustDaily',
            prepareLabels: elem => {
              let dateArr = elem[0].split('-');
              let month = parseInt(dateArr[1]) - 1;

              return [elem[0].slice(-2), this.month[month]];
            },
          },
          {
            title: 'За период',
            isDatePeriod: true,
            dateRange: {
              from: null,
              to: null,
            },
            method: 'getTrustDaily',
            prepareLabels: elem => {
              let dateArr = elem[0].split('-');
              let month = parseInt(dateArr[1]) - 1;

              return [elem[0].slice(-2), this.month[month]];
            },
          },
        ],
        active: 0,
        isDatePeriod: false,
      },
    };
  },
  computed: {
    activePeriod() {
      return this.period.periodList[this.period.active].title;
    },
  },
  methods: {
    HandleChange(range) {
      const from = moment(range[0]).format(FORMAT);
      const to = moment(range[1]).format(FORMAT);

      this.period.periodList[this.period.active].dateRange = { from, to };
      this.toEmit();
    },
    choosePeriod(key) {
      this.period.active = key;
      this.period.isDatePeriod = this.period.periodList[this.period.active].isDatePeriod;

      if (this.period.periodList[this.period.active].dateRange.from) {
        this.toEmit();
      }
    },
    toEmit() {
      this.$emit('onChooseDate', {
        range: this.period.periodList[this.period.active].dateRange,
        method: this.period.periodList[this.period.active].method,
        prepareLabels: this.period.periodList[this.period.active].prepareLabels,
        activePeriod: `${this.activePeriod} на ${moment().format('DD.MM.YYYY HH:mm')}`,
      });
    },
  },
  mounted() {
    bus.$on('restartPeriod', () => {
      this.period.active = 0;
    });
  },
  components: {
    RangeDatePicker,
  },
};
</script>

<style>
  .report-area__date-controls {
    display: flex;
    padding: 0;
    margin: 0 10px 0 0;
    list-style: none;
  }

  .report-area__date-controls-item {
    position: relative;
  }
  .report-area__date-controls-item:last-child {
    margin-right: 0;
  }

  .report-area__date-controls-button {
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 6px 0 6px 4px;
    width: 110px;
    font-family: "Oswald", "Arial", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    text-transform: uppercase;
    color: #ffffff;
    background-color: #0085ff;
    border: none;
    outline: none;
    cursor: pointer;
  }

  .report-area__date-controls-button--less {
    display: none;
  }

  .period-list {
    display: none;
    position: absolute;
    right: 0;
    margin: 0;
    padding: 0;
    width: 110px;
    list-style: none;
    border-radius: 4px;
  }

  .period-list__decor {
    position: absolute;
    top: 8px;
    left: 49px;
    width: 15px;
    height: 15px;
    background-color: #0085ff;
    transform: rotate(45deg);
  }

  .period-list__item {
    background-color: #0085ff;
  }

  .period-list__item--empty {
    height: 15px;
    background-color: transparent;
  }

  .period-list__item-button {
    padding: 8px 0;
    width: 100%;
    font-family: "Oswald", "Arial", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 10px;
    line-height: 20px;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: #ffffff;
    background-color: #0085ff;
    border-radius: 4px;
    border: none;
    cursor: pointer;
    outline: none;
  }

  .report-area__date-controls-item:hover .period-list {
    display: flex;
    flex-direction: column;
  }

  .report-area__date-controls-item:hover .report-area__date-controls-button--more {
    display: none;
  }

  .report-area__date-controls-item:hover .report-area__date-controls-button--less {
    display: block;
  }
</style>
